module.exports = __webpack_public_path__ + "img/garten2.31f4756d.jpg";